// Modules
import styled from 'styled-components';

// Types
import { styledComponentProps } from '../../types/theme';

export const EventListView = styled.div`
	margin: 40px 0;

	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.sm} {
		margin: 40px 30px
	 }
`;
